import { osName, isIOS, isMobile } from "react-device-detect";

declare global {
  interface Window {
    Android?: any;
    webkit?: any;
    WebBridge: {
      // [appToWeb] Webview 뒤로가기 or 종료
      onBackPress?: () => void;
      /**
       * [appToWeb][deprecated][androidOnly] Feed 상세 페이지내에서 download 실행시 project file을 download 받도록하는 App에서 이벤트를 호출하는 함수
       * @param projectId project feed id
       * @param percentage project file downloading percentage (0 - 100)
       * @param status project file download status *(0: none, 1: download cancel, 2: free disk space error, 3: network error)*
       * @param errorCode error code
       */
      onProgressStatus?: (args: string) => void;
      /**
       * [appToWeb] Feed 상세 페이지내에서 download 실행시 project file을 download 받도록하는 App에서 이벤트를 호출하는 함수
       * @param projectId project feed id
       * @param percentage project file downloading percentage (0 - 100)
       * @param status project file download status *(0: none, 1: download cancel, 2: free disk space error, 3: network error)*
       * @param errorCode error code
       */
      onDownloadProgress?: (args: string) => void;
      /**
       * [appToWeb] Feed 상세 페이지내에서 download 실행후 download 받은 file을 설치할때 App에서 호출하는 함수
       * @param projectId project feed id
       * @param percentage project file downloading percentage (0 - 100)
       * @param errorCode error code
       */
      onInstallProgress?: () => void;
      // [appToWeb] Android 디바이스 홈버튼 눌러 앱이 pause 시 호출 함수 (Android 5.0.4.21370 적용)
      pause?: () => void;
      // [appToWeb] Android 디바이스 앱이 pause 상태에서 resume 시 호출 함수 (Android 5.0.4.21370 적용)
      resume?: () => void;
    };
  }
}

// 앱에서 호출 시, 런타임 에러를 방지하기 위해 약속된 브릿지 함수들을 초기화
const initWebBridge = (name: TGetWebBridge) => {
  if (!window.WebBridge) {
    window.WebBridge = {};
  }
  if (!window.WebBridge[name]) {
    window.WebBridge[name] = () => {};
  }
};

type TGetWebBridge =
  | "onBackPress"
  | "onDownloadProgress"
  | "onInstallProgress"
  | "onProgressStatus"
  | "pause"
  | "resume";
interface IGetWebBridge {
  name: TGetWebBridge;
  callBack: (args?: any) => any;
}
export const getWebBridge = (props: IGetWebBridge) => {
  initWebBridge(props.name);
  try {
    window.WebBridge[props.name] = props.callBack;
  } catch (err) {
    if (!isMobile) return console.log(`${props.name} not support desktop`);
    console.error(`${props.name} is error: ${err}`);
  }
};

type TSetWebBridge =
  | "onWebClose"
  | "onUpdateApplication"
  | "onDownloadStart"
  | "onDownloadCancel"
  | "onShareStart"
  | "logEvent";

interface ISetWebBridge {
  args?: string;
  name: TSetWebBridge;
}
export const setWebBridge = (props: ISetWebBridge) => {
  const args = props.args ? Buffer.from(props.args).toString("base64") : null;
  try {
    // args 없는 경우와 있는 경우 아래와 같이 실행해야 webBridge 연동됨
    if (osName === "iOS" || osName === "Mac OS" || isIOS) {
      args
        ? window.webkit.messageHandlers[props.name].postMessage(args)
        : window.webkit.messageHandlers[props.name].postMessage("");
    } else {
      args ? window.Android[props.name](args) : window.Android[props.name]();
    }
    // webBridge Firebase 이벤트를 위해 logEvent 예외처리
    // if (props.name !== "logEvent") {
    //   firebaseEvent(props.fbEventName, props.fbEventParams);
    // }
  } catch (err) {
    // share update popup 띄우기 위해 error 전달
    if (props.name === "onShareStart") throw new err();
    if (!isMobile) return console.log(`${props.name} not support desktop`);
    console.error(`${props.name} is error: ${err}`);
  }
};
